import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-calendar',
  imports: [],
  templateUrl: './calendar.html',
  styleUrl: './calendar.scss',
})
export class Calendar {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
